import { cva, type VariantProps } from 'class-variance-authority';

/**
 * HEN Input variants using HEN Design System tokens.
 * All styling references design tokens defined in tailwind.config.ts.
 */
export const inputVariants = cva(
  [
    // Base styles - structural styles only
    'flex w-full',
    'h-11',
    'font-body',
    'rounded-sm',
    'text-body text-b5',
    'px-xs py-xxs',
    'placeholder:text-subtext',
    'transition-colors duration-200',
    // File input styles
    'file:border-0 file:bg-transparent file:text-sm file:font-medium',
    // Focus styles - visible focus ring per WCAG 2.1 AA
    // Override shadcn ring styles
    'focus-visible:outline-none',
    'focus-visible:ring-0',
    'focus-visible:ring-offset-0',
    // Disabled styles
    'disabled:cursor-not-allowed',
    'disabled:opacity-60',
  ],
  {
    variants: {
      variant: {
        default: [
          // Background and border colors
          'bg-white',
          'text-primary-700',
          'border border-neutral-200',
          // Hover effect
          'hover:border-neutral-300',
          // Focus effect
          'focus-visible:border-neutral-500',
          'focus-visible:ring-2',
          'focus-visible:ring-neutral-100', // Disabled colors
          'disabled:bg-neutral-100',
          'disabled:border-neutral-200',
          'disabled:text-subtext',
        ],
        'two-line': [
          // Background and border colors - same as default
          'bg-white',
          'text-primary-700',
          'border border-neutral-200',
          // Hover effect
          'hover:border-neutral-300',
          // Focus effect
          'focus-visible:border-neutral-500',
          'focus-visible:ring-2',
          'focus-visible:ring-neutral-100', // Disabled colors
          'disabled:bg-neutral-100',
          'disabled:text-subtext',
          // Two-line specific: extra height for floating label
          'h-11',
          'pt-5 pb-1.5',
        ],
      },
      error: {
        true: [
          // Error border
          'border-error-500',
          'text-error-500',
          // Error focus styles
          'focus-visible:border-error-500',
          'focus-visible:ring-2',
          'focus-visible:ring-error-100',
        ],
        false: '',
      },
    },
    defaultVariants: {
      variant: 'default',
      error: false,
    },
  },
);

export type InputVariantProps = VariantProps<typeof inputVariants>;
